import Div from './Div.js';

export default class Title extends Div { }